import type { Notification, PushNotificationTrigger } from 'expo-notifications';

import type { BackgroundNotification } from '@/features/notifications/types/backgroundNotification';
import type { NotificationData } from '@/features/notifications/types/notificationData';

export const getNotificationData = (
  notification?: Notification
): NotificationData | undefined => {
  try {
    if (!notification) return;

    let eventName = notification.request?.content?.data?.['eventName'] as
      string | undefined;

    let eventString = notification.request?.content?.data?.['event'] as
      string | undefined;

    let event: object | undefined = undefined;

    if (
      !eventName &&
      notification.request?.trigger &&
      (Object.hasOwn(notification.request?.trigger, 'payload') ||
        Object.hasOwn(notification.request?.trigger, 'remoteMessage'))
    ) {
      const pushTrigger = notification.request
        ?.trigger as PushNotificationTrigger;

      const apsPayload = pushTrigger.payload?.['aps'] as
        Record<string, unknown> | undefined;

      if (apsPayload) {
        eventName =
          (apsPayload['categoryName'] as string | undefined) ??
          (apsPayload['category'] as string | undefined);
        if (typeof apsPayload['event'] === 'string')
          eventString = apsPayload['event'];
        else if (typeof apsPayload['event'] === 'object') {
          event = apsPayload['event'] as object;
        }
      } else if (pushTrigger.remoteMessage?.data) {
        eventName = pushTrigger.remoteMessage.data['eventName'];

        if (typeof pushTrigger.remoteMessage.data['event'] === 'string')
          eventString = pushTrigger.remoteMessage.data['event'];
        else if (typeof pushTrigger.remoteMessage.data['event'] === 'object') {
          event = pushTrigger.remoteMessage.data['event'];
        }
      }
    }

    if (!eventName) return;

    return { eventName, eventString, event };
  } catch (error) {
    console.error(error);
    return;
  }
};

export const getRelatedEntityId = (
  key: 'postId' | 'groupId' | 'chatId' | 'organizationId',
  data: NotificationData
) => {
  if (!data.eventString && !data.event) return;
  const event = (data.event ?? JSON.parse(data.eventString!)) as {
    [key]: string;
  };

  return event[key];
};

export const getBackgroundNotificationData = (
  notification?: BackgroundNotification
): NotificationData | undefined => {
  try {
    if (!notification) return;
    if (!notification.aps && !notification.data) return;

    const eventName =
      notification.aps?.categoryName ??
      notification.aps?.category ??
      notification.data?.eventName;

    let eventString = notification.data?.event;

    let event = notification.aps?.event;

    if (!event && eventString) {
      try {
        event = JSON.parse(eventString) as object;
      } catch (error) {
        console.error(error);
      }
    } else if (event && !eventString) {
      try {
        eventString = JSON.stringify(event);
      } catch (error) {
        console.error(error);
      }
    }

    if (!eventName) return;

    return { eventName, eventString, event };
  } catch (error) {
    console.error(error);
    return;
  }
};
